// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d654adb4","971":"850959c1"}[chunkId] + ".chunk.js";
};